var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-1",staticStyle:{"cursor":"pointer"},attrs:{"width":"95","height":"136"}},[_c('img',{staticStyle:{"height":"100%"},attrs:{"alt":"Game Logo","src":_vm.cardImageURL,"transition":"scale-transition"},on:{"click":_vm.openCard}})])
}
var staticRenderFns = []

export { render, staticRenderFns }